import { render, staticRenderFns } from "./CyltpDetail.vue?vue&type=template&id=2fff7528&scoped=true"
import script from "./CyltpDetail.vue?vue&type=script&lang=js"
export * from "./CyltpDetail.vue?vue&type=script&lang=js"
import style0 from "./CyltpDetail.vue?vue&type=style&index=0&id=2fff7528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fff7528",
  null
  
)

export default component.exports